export { View as LoanFormLayout } from './view'
